import DateDisplay from 'components/DateDisplay';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the finishedAt.
 */
export default function FinishedAtColumn({ data: { finishedAt } }: { data: RevisionRow }) {
  return finishedAt ? <DateDisplay date={new Date(finishedAt)} withRelative={false} /> : '';
}
